/*
 * @Author: Xun Tian
 * @Date: 2022-10-08
 * @Last Modified by: Xun Tian
 * @Last Modified time:
 * @Description:公共api文件
 */

import { defHttp } from 'xmgoing-server';
import { axiosHelpers } from '@/api/request';
import { createAxios } from "xmgoing-server";

enum Api {
  GetUserInfo = '/pe-portal/users/getUserInfo',
  updateAvatar = '/pe-attachment/attachment/upload',
  viewAvatar = '/pe-attachment/attachment/showImg',
  GatewayHostUrl = '/go-fks/ipaas/endpoint/gatewayHost',
  ReadMsgUrl = '/pe-message/inBoxMessage/notReadList',
  updatePwd = '/pe-portal/users/updatePwd',
  loadPwdConfig = '/pe-portal/appStartConfig/getPwdSetting',
  loadUpdatePwdFlag = '/pe-portal/users/checkPwdLimit',
  explain = '/go-lcc/appTemplate/getExplainDoc',
  getTenantByAccount = '/pe-portal/users/getTenantByAccount',
  getUserLoginKey = '/blade-auth/login/getUserLoginKey?current=1&size=20',
  token = '/blade-auth/oauth/token',
  desByCode = '/go-lcc/customPage/getByCode',
  updateLog = '/go-lcc/updateLog/latest',
  updateLogList = '/go-lcc/updateLog/list',
  updateLogDetail = '/go-lcc/updateLog/detail',
  updateLogGroupSave = '/go-lcc/updateLog/group/save',
  updateLogGroupRemove = '/go-lcc/updateLog/group/remove',
  updateLogItemSave = '/go-lcc/updateLog/item/save',
  updateLogItemRemove = '/go-lcc/updateLog/item/remove',
  productionSave = '/go-lcc/dataease/production/save',
}

/**
 * @description: 获取密码加密
 */
export async function tokenApi(data: any) {
  return axiosHelpers.post(Api.token, data);
}

/**
 * @description: 获取密码加密
 */
export async function getUserLoginKeyApi() {
  return defHttp.get<any>({ url: Api.getUserLoginKey });
}

/**
 * @description: 获取租户
 */
export async function getTenantByAccount(account: string) {
  return defHttp.get<any>({ url: Api.getTenantByAccount, params: { account } });
}

/**
 * @description: getUserInfo
 */
export function getUserInfo() {
  return defHttp.get<any>({ url: Api.GetUserInfo }, { errorMessageMode: 'none' });
}

// 上传头像
export function updateAvatar(data: any) {
  return defHttp.post<any>({ url: Api.updateAvatar, data });
}
// 查看头像
export function viewAvatar(id: string) {
  return '/api' + Api.viewAvatar + `/${id}`;
}
// 查询未读消息
export function getReadMsg() {
  return defHttp.get<any>({ url: Api.ReadMsgUrl }, { errorMessageMode: 'none' });
}
// 更新密码
export function updatePwdApi(data: any) {
  return defHttp.post<any>({ url: Api.updatePwd, data });
}
//获取强制修改密码的标志
export async function loadUpdatePwdFlag(data: any) {
  return defHttp.get<any>({ url: Api.loadUpdatePwdFlag, data });
}

/**
 * 获取密码修改配置信息
 * @param data
 */
export async function loadPwdConfig(data: any) {
  return defHttp.get<any>({ url: Api.loadPwdConfig, data });
}
// 获取模板信息
export function getTemplateexplain(id: any) {
  return defHttp.get({ url: Api.explain, params: { id } });
}

export function getPageDesByCode({pageCode,moduleCode}:any) {
  return defHttp.get({ url: Api.desByCode, params: { pageCode,moduleCode } });
}

/**
 * 获取最新更新日志
 */
export function getUpdateLog() {
  return defHttp.get<any>({ url: Api.updateLog }, { errorMessageMode: 'none' });
}

export function getUpdateLogList() {
  return defHttp.get<any>({ url: Api.updateLogList }, { errorMessageMode: 'none' });
}

export function getUpdateLogDetail(id: string | number) {
  return defHttp.get<any>({ url: Api.updateLogDetail, params: { id } }, { errorMessageMode: 'none' });
}

export function saveUpdateLogGroup(data: any) {
  return defHttp.post<any>({ url: Api.updateLogGroupSave, data }, { errorMessageMode: 'none' });
}

export function removeUpdateLogGroup(id: string | number) {
  return defHttp.post<any>({ url: Api.updateLogGroupRemove, data: { id, ids: id } }, { errorMessageMode: 'none' });
}

export function saveUpdateLogItem(data: any) {
  return defHttp.post<any>({ url: Api.updateLogItemSave, data }, { errorMessageMode: 'none' });
}

export function removeUpdateLogItem(id: string | number) {
  return defHttp.post<any>({ url: Api.updateLogItemRemove, data: { id, ids: id } }, { errorMessageMode: 'none' });
}

/**
 * 复用投产管理的新增接口，创建一条 CoreProduction 投产记录
 */
export function saveProduction(data: { name?: string; bizType: string; bizId: string; version?: string; versionId?: string }) {
  return defHttp.post<any>({ url: Api.productionSave, data });
}


export function setNotNewUser({}){
  return defHttp.get({ url: '/pe-portal/users/setNotNewUser', params: {} });
}

const service:any = createAxios({
  baseURL: import.meta.env.VITE_APP_BASE_API, // api的base_url
  withCredentials: true,
  timeout: 30000, // 请求超时时间
});


export const axiosHelpers = service.helpers;
